<template>
  <div class="equipment-summary-container">
    <!-- Essential -->
    <template v-if="equipment.essential.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield" />
        Security Equipment
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="e in equipment.essential" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div>{{ e.description }}</div>
          </div>
          <div class="equipment-pricing">
            <div>{{ e.quantity }}</div>
            <div class="text-blue text-bold">free</div>
          </div>
        </div>
      </div>
    </template>

    <!-- Cameras -->
    <template v-if="equipment.cameras.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield" />
        Cameras and video
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="(e, index) in equipment.cameras" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div>{{ e.description }}</div>
          </div>
          <div class="equipment-pricing">
            <div>
              <NumberInput
                :value="e.quantity"
                controls
                @change="(value) => updateCartItemQuantity(e.id, e.price, value)"
              />
            </div>
            <div class="text-blue text-bold" v-html="calculateSubtotal(e, index)"></div>
          </div>
        </div>
        <div class="add-more-section">
          <hr />
          <router-link to="/cameras?continue-to-system=true">Add more camera devices</router-link>
        </div>
      </div>
    </template>

    <!-- Home Automation -->
    <template v-if="equipment.homeAutomation.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield" />
        Home Automation
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="(e, index) in equipment.homeAutomation" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div>{{ e.description }}</div>
          </div>
          <div class="equipment-pricing">
            <div>
              <NumberInput
                :value="e.quantity"
                controls
                @change="(value) => updateCartItemQuantity(e.id, e.price, value)"
              />
            </div>
            <div class="text-blue text-bold" v-html="calculateSubtotal(e, index)"></div>
          </div>
        </div>
        <div class="add-more-section">
          <hr />
          <router-link
            to="/home-automation?continue-to-system=true"
          >Add more home automation devices</router-link>
        </div>
      </div>
    </template>

    <!-- Environmental equipment -->
    <template v-if="equipment.environmental.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield" />
        Environmental equipment
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="e in equipment.environmental" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div v-html="e.description"></div>
          </div>
          <div class="equipment-pricing">
            <div>
              <NumberInput
                :value="e.quantity"
                controls
                @change="(value) => updateCartItemQuantity(e.id, e.price, value)"
              />
            </div>
            <div class="text-blue text-bold">{{ calculateSubtotal(e) }}</div>
          </div>
        </div>
        <div class="add-more-section">
          <hr />
          <router-link
            to="/environmental?continue-to-system=true"
          >Add more environmental devices</router-link>
        </div>
      </div>
    </template>

    <!-- Window equipment -->
    <template v-if="equipment.window && equipment.window.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield" />
        Window equipment
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="(e, index) in equipment.window" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div v-html="e.description"></div>
          </div>
          <div class="equipment-pricing">
            <div>
              <NumberInput
                :value="e.quantity"
                controls
                @change="(value) => updateCartItemQuantity(e.id, e.price, value)"
              />
              <!-- <div>{{ e.quantity }}</div> -->
            </div>
            <div class="text-blue text-bold">{{ calculateSubtotal(e, index) }}</div>
          </div>
        </div>
      </div>
    </template>

    <!-- Additional equipment -->
    <template v-if="equipment.additional && equipment.additional.length">
      <div class="title-bar">
        <img src="/img/icon-shield@2x.png" alt="shield" />
        Additional equipment
      </div>
      <div class="equipment-section">
        <div class="equipment-row" v-for="e in equipment.additional" :key="e.id">
          <div>
            <img class="equipment-image" :src="e.image" alt />
          </div>
          <div class="flex-grow">
            <div class="text-bold">{{ e.name }}</div>
            <div v-html="e.description"></div>
          </div>
          <div class="equipment-pricing">
            <div>
              <!-- <NumberInput
                :value="e.quantity"
                controls
                @change="(value) => updateCartItemQuantity(e.id, e.price, value)"
              /> -->
              <div>{{ e.quantity }}</div>
            </div>
            <div class="text-blue text-bold">{{ calculateSubtotal(e) }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import formatCurrency from '../Libraries/formatCurrency'
import NumberInput from "./NumberInput.vue";
import { mapActions } from 'vuex';
export default {
  components: {
    NumberInput
  },
  props: {
    equipment: {
      type: Object,
      required: true,
      default: () => ({
        essential: [],
        cameras: []
      })
    }
  },
  data: () => ({
    equipmentData: {}
  }),
  methods: {
    /**
     * Update the quantity of item in cart
     * adds to cart if item doesn't exist
     */
    updateCartItemQuantity(id, price, quantity) {
      this.$emit('change', {
        id: id,
        price: price,
        quantity: quantity
      })
    },

    calculateSubtotal(item, rowIndex) {
      let rowIndexWithDiscount = 0

      let subtotal = item.price * item.quantity

      if (item.category === 'automation') {
        let automationEquipment = this.equipment.homeAutomation
        if (automationEquipment[0].price < 199) {
          rowIndexWithDiscount = 1
        }
      }
      let isCameraDiscount = rowIndex === rowIndexWithDiscount && item.category === 'camera'

      let automationDiscount = rowIndex === rowIndexWithDiscount && item.category === 'automation'

      let hasDiscount = isCameraDiscount || automationDiscount

      if (hasDiscount) {
        let discountedSubtotal = item.price * (item.quantity - 1)

        return `<div>
          <span style="text-decoration: line-through; font-size: .9em; margin-right: 3px;">${formatCurrency(subtotal)}</span>
          <span>${discountedSubtotal ? formatCurrency(discountedSubtotal) : 'free'}</span>
        </div>`
      }

      return formatCurrency(subtotal)
    }
  },

  updated() {
    this.equipmentData = this.equipment
  }
  
};
</script>

<style lang="scss" scoped>
.equipment-summary-container {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  @media (max-width: 480px) {
    margin: 0 -1rem;
    box-shadow: none;
  }
}
.title-bar {
  background: #f6f6f6;
  color: #9e9e9e;
  padding: 0.8rem 1rem 0.8rem 4rem;
  display: flex;
  align-items: center;
  @media (max-width: 480px) {
    padding-left: 1rem;
  }

  img {
    max-width: 20px;
    margin-right: 0.9rem;
  }
}

.equipment-row {
  display: flex;
  padding: 1.5rem 4rem;
  @media (max-width: 480px) {
    font-size: 12px;
    padding: 1rem 1.25rem;
  }

  ::v-deep .number-input {
    @media (max-width: 480px) {
      width: 100px;
    }
  }
  ::v-deep .number-input__input {
    font-size: 12px;
    padding: 0.4375rem 0.875rem;
  }
  ::v-deep .number-input__button {
    width: 30px;
    &:before { width: 8px; }
    &:after { height: 8px; }
  }
}

.equipment-image {
  width: 50px;
  display: block;
  margin-right: 1.875rem;
  @media (max-width: 480px) {
    margin-right: 1rem;
  }
}

.equipment-pricing {
  width: 90px;
  text-align: right;
}

.add-more-section {
  padding: 1rem 4rem;
  text-align: right;
  font-weight: bold;
  @media (max-width: 480px) {
    padding: 1rem 1.25rem;
  }
  a {
    text-decoration: none;
  }
}
</style>
